import React, { useState, useEffect, useRef } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import {
  InputAdornment,
  IconButton,
  makeStyles,
  TextField,
} from "@material-ui/core";
import brandTheme from "brandTheme/Theme";
import DateRange from "@material-ui/icons/DateRange";
import { parseDate } from "utils/Utils";

const formatDateDisplay = (date) => {
  if (!date) return "";
  const d = new Date(date);
  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();
  return `${day}-${month}-${year}`;
};

const parseInputDate = (input) => {
  const parts = input.split("-");
  if (parts.length === 3) {
    return `${parts[2]}-${parts[1]}-${parts[0]}`;
  }
  return "";
};

const useStyles = makeStyles((theme) => ({
  inputBox: {
    marginBottom: "1%",
    position: "relative",

    "& .MuiOutlinedInput-root": {
      // "& fieldset": {
      //   borderColor: brandTheme.mainColor,
      // },

      "&:hover fieldset": {
        borderColor: brandTheme.mainColor,
      },

      "&.Mui-focused fieldset": {
        borderColor: brandTheme.mainColor,
        borderWidth: "2px",
      },

      // "& input": {
      //   color: brandTheme.mainColor,
      // },
    },

    // "& .MuiFormLabel-root": {
    //   color: brandTheme.mainColor,
    // },

    "& .MuiFormLabel-root.Mui-focused": {
      color: brandTheme.mainColor,
      fontWeight: 600,
    },

    "& .MuiFormLabel-root.Mui-disabled": {
      color: brandTheme.lightBlack,
    },

    // "& .MuiInputAdornment-root .MuiSvgIcon-root": {
    //   color: brandTheme.mainColor,
    // },
  },

  calendarPopup: {
    position: "absolute",
    zIndex: 1000,
    background: "white",
    boxShadow: "0px 10px 30px rgba(0,0,0,0.12)",
    borderRadius: "16px",
    padding: "10px",
    overflow: "hidden",
  },
}));

const CustomDateField = (
  {
    label, 
  value, 
  onChange, 
  className, 
  disabled,
  minYears,
  maxYears,
  }
  ) => {
  const [date, setDate] = useState(value ? new Date(value) : null);
  const [showCalendar, setShowCalendar] = useState(false);
  const [calendarPosition, setCalendarPosition] = useState({ top: 0, left: 0 });
  const inputRef = useRef(null);
  const classes = useStyles();
    const today = new Date();

  const minDate = maxYears
    ? new Date(
        today.getFullYear() - maxYears,
        today.getMonth(),
        today.getDate()
      )
    : undefined;

  const maxDate = minYears
    ? new Date(
        today.getFullYear() - minYears,
        today.getMonth(),
        today.getDate()
      )
    : undefined;
  useEffect(() => {
    if (value) {
      setDate(new Date(value));
    }
  }, [value]);

  const handleDateChange = (newDate) => {
    setDate(newDate);
    setShowCalendar(false);
    const formattedDate = parseDate(newDate);
    onChange(formattedDate);
  };

  const handleInputChange = (event) => {
    const inputValue = event.target.value;
    const parsedDate = parseInputDate(inputValue);

    if (!isNaN(new Date(parsedDate).getTime())) {
      setDate(new Date(parsedDate));
      onChange(parsedDate);
    } else {
      setDate(null);
      onChange("");
    }
  };

  const toggleCalendar = () => {
    if (inputRef.current) {
      const rect = inputRef.current.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      const calendarHeight = 300; // approx height of calendar
      const fitsBelow = rect.bottom + calendarHeight < windowHeight;

      setCalendarPosition({
        top: fitsBelow ? rect.height + 4 : -calendarHeight - 4,
        left: 0,
      });
    }
    setShowCalendar((prev) => !prev);
  };

  return (
    <div className={classes.inputBox} ref={inputRef}>
      <TextField
        label={label}
        value={date ? formatDateDisplay(date) : ""}
        onChange={handleInputChange}
        fullWidth
        variant="outlined"
        onFocus={toggleCalendar}
        disabled={disabled}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton onClick={toggleCalendar} disabled={disabled}>
                <DateRange />
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
      {showCalendar && (
        <div
          className={classes.calendarPopup}
          style={{
            top: calendarPosition.top,
            left: calendarPosition.left,
          }}
        >
          <Calendar
            onChange={handleDateChange}
            value={date}
            className={className}
            minDate={minDate}
            maxDate={maxDate}
          />
        </div>
      )}
    </div>
  );
};

export default CustomDateField;
